"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minWidth = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _styles = require("@material-ui/core/styles");
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _CircularProgress = _interopRequireDefault(require("../../CircularProgress"));
var _excluded = ["handleClearInput"];
var minWidth = 222;
exports.minWidth = minWidth;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    disabled: {
      color: theme.palette.opacity.black[38]
    },
    endAdornment: {
      cursor: 'pointer',
      marginRight: '8px'
    },
    multiInput: {
      '&:hover': {
        background: 'auto'
      },
      borderRadius: '2px 2px 0 0',
      display: 'flex',
      height: 36,
      minWidth: minWidth,
      padding: 0,
      paddingBottom: 1,
      width: '100%'
    },
    startAdornment: {
      marginRight: '8px'
    }
  };
});
var useMuiInputStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.white,
      borderRadius: '2px 2px 0 0',
      cursor: 'default',
      display: 'flex',
      fontSize: '13px',
      height: 36,
      minWidth: minWidth,
      padding: 0,
      paddingLeft: 8,
      width: '100%'
    }
  };
});
var SearchInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = useStyles();
  var inputClasses = useMuiInputStyles();
  var componentProps = props.componentProps,
    commonProps = props.commonProps;
  var automationid = commonProps.automationid,
    dataMetrics = commonProps.dataMetrics,
    isDisabled = commonProps.isDisabled,
    isLoading = commonProps.isLoading,
    searchInputValue = commonProps.searchInputValue,
    variant = commonProps.variant;
  var handleClearInput = componentProps.handleClearInput,
    searchInputProps = (0, _objectWithoutProperties2["default"])(componentProps, _excluded);
  var startAdornment = /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    className: (0, _classnames["default"])(classes.startAdornment, (0, _defineProperty2["default"])({}, classes.disabled, isDisabled)),
    color: "action"
  });
  var endAdornment = false;
  if (isLoading) {
    endAdornment = /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
      className: classes.endAdornment,
      size: "small"
    });
  } else if (searchInputValue.length > 0) {
    endAdornment = /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      onClick: handleClearInput,
      className: classes.endAdornment,
      color: "action"
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.multiInput,
    automationid: "".concat(automationid, "-search-input-wrapper"),
    "data-metrics": dataMetrics.searchInputWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
    autoFocus: variant !== 'standalone',
    automationid: "".concat(automationid, "-search-input"),
    classes: inputClasses,
    "data-metrics": dataMetrics.searchInput,
    disabled: isDisabled,
    disableUnderline: true,
    endAdornment: endAdornment,
    inputRef: ref,
    startAdornment: startAdornment
  }, searchInputProps)));
});
SearchInput.propTypes = process.env.NODE_ENV !== "production" ? {
  commonProps: _propTypes["default"].object,
  componentProps: _propTypes["default"].object
} : {};
var _default = SearchInput;
exports["default"] = _default;